/// <amd-module name="Agile/Directory/Components/DirectoryGrid/TeamCell" />
import { IDirectoryRow } from "Agile/Directory/Components/DirectoryGrid/DirectoryGrid.Props";
import { IDirectoryArtifact } from "DirectoryContracts";
import * as React from "react";
import { IProjectData } from "Tfs/Platform/Page";
import { TeamPanelIconButton } from "TFS/TeamPanel/TeamPanelIcon/TeamPanelIcon";
import { Tooltip } from "VSSUI/TooltipEx";

export interface ITeamCellProps<T extends IDirectoryArtifact> {
    row: IDirectoryRow<T>;
    project: IProjectData;
}

export class TeamCell<T extends IDirectoryArtifact> extends React.PureComponent<ITeamCellProps<T>> {
    public render(): JSX.Element {
        const {
            row: { data },
            project
        } = this.props;

        if (!data || !data.owners || data.owners.length === 0) {
            return <div />;
        }

        //TODO: Eventually, we need to support multiple team panes
        const content = data.owners.map(o => o.name).join(", ");

        return (
            <div className="directory-row-team-cell">
                <TeamPanelIconButton projectName={project.name} projectId={project.id} teamId={data.owners[0].id} teamName={data.owners[0].name} />

                <Tooltip overflowOnly={true} text={content}>
                    <span className="team-name flex-tooltip-host">{content}</span>
                </Tooltip>
            </div>
        );
    }
}
